import { Lock } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useAuth } from "@/features/auth/hooks/useAuth"

/** An authenticated account with nothing it may open (e.g. its jurisdiction was withdrawn). */
export function NoAccess() {
  const { logout, isLoggingOut } = useAuth()
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <Lock className="mx-auto h-8 w-8 text-muted-foreground" aria-hidden />
        <h1 className="text-lg font-semibold">No demonstration access</h1>
        <p className="text-sm text-muted-foreground">
          This account has no district or organisation assigned. Please contact the administrator.
        </p>
        <Button variant="outline" onClick={logout} disabled={isLoggingOut}>Sign out</Button>
      </div>
    </div>
  )
}
